import { nanoid } from 'nanoid'
import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,
    Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const navigate = useNavigate();

    const { convertToFloat, paymentCalculation } = Helpers


    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        onResetForm()
        closeModal()
    }

    const handleClickCloseForm = () => {
        const { FormRequestGlobal } = Forms
        const { onResetForm } = FormRequestGlobal
        onResetForm()
        // navigate si funcionó
        navigate('/administrador-creditos-gestiones')
    }


    const handleChangeContract = async (event) => {

        //HOOKS
        const { FormRequestGlobal } = Forms
        const { setFormState, formState } = FormRequestGlobal

        const { setShowFormContract, showFormContract } = globalStates

        const { fetchInfoContract: { executeFetchInfoContract } } = FetchData

        const { name, value } = event.target

        setFormState(prevState => ({
            ...prevState,
            [name]: value
        }))

        await executeFetchInfoContract()

        setShowFormContract(true)
    }

    const onSubmitFormRequests = async (e) => {
        e.preventDefault()

        const { FormRequestGlobal } = Forms
        const { formState } = FormRequestGlobal

        const { getCurrentDate } = Helpers
        const { fetchAllDeposits } = FetchData
        const { deposits } = fetchAllDeposits

        // Extraer IDs de los depósitos relacionados
        const depositIds = deposits ? deposits.map(deposit => deposit.idmovimiento) : []

        const _body = {
            idgestion: formState.idgestion,
            aprobacion_check: formState.aprobacion_check,
            aprobacion_fecha: getCurrentDate(),
            aprobacion_usuario: user.username,
            deposit_ids: depositIds
        }

        if (formState.aprobacion_check !== 'Pendiente Aprobacion') {
            await marvarApi.put(`/credits/admin-management/aprobacion-check`, _body)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        handleClickCloseForm()
                    }
                })
        }
    }

    const onSendLogs = async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        // const { fetchAllTypeManagements:{typeManagements} } = FetchData

        await marvarApi.post(`/credits/common/log-management/${formState.idgestion}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers



        const _data = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_referencia_ach: formState.aprobacion_referencia_ach,
            aprobacion_observaciones: formState.aprobacion_observaciones,
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate()
        }

        await marvarApi.put(`/credits/admin-management/aprobacion-check-deposit/${formState.idmovimiento}`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllDeposits()
                    closeModal()
                }

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers

        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idgestiontipo', formState.idgestiontipo);
        _data.append('idcredito', formState.idcredito);
        _data.append('department', '');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/credits/mgmt-managements/create-document`, _data)
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            check_carta: true,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickFetchInfoDeposit = async (idmovimiento) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        executeFetchInfoDeposit()

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')
    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const handleChangeTypeLoan = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChange } } = Forms
        const { clean_saldo_financiado, nuevo_plazo, clean_gps, clean_seguro, clean_otros } = formState

        const { name, value } = event.target


        onInputChange(event)
        const interes_float = (parseFloat(value) / 100).toFixed(4)

        const interes_total_data = parseFloat((value * 12).toFixed(2));
        // console.log(interes_float, interes_total_data);

        const cuota_niv = paymentCalculation(clean_saldo_financiado, 0, value, nuevo_plazo)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);


        setFormState(prevState => ({
            ...prevState,
            interes_total: `${interes_total_data} %`,
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            nuevo_total_cuota: numberFormatter.format(cuota_total)
        }))
    }

    const handleChangeTerm = (event) => {

        const { name, value } = event.target

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState } } = Forms

        const {
            clean_saldo_financiado,
            clean_gps,
            clean_seguro,
            clean_otros,
            interes,
        } = formState
        const cuota_niv = paymentCalculation(clean_saldo_financiado, 0, interes, value)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);


        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        setFormState(prevState => ({
            ...prevState,
            [name]: value,
            plazo_anios: (value / 12).toFixed(2),
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            clean_nuevo_cuota_niv: cuota_niv,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }


    const handleChangeGPS = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_seguro,
            clean_otros
        } = formState

        const cuota_total = (parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_value) + parseFloat(clean_otros) + parseFloat(clean_seguro));

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleChangeSeguro = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, onInputChangeForNumber, formState } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_gps,
            clean_otros
        } = formState

        const cuota_total = parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_value) + parseFloat(clean_otros);

        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,

        }))
    }

    const handleChangeOtros = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_gps,
            clean_seguro
        } = formState

        const cuota_total = parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_value);

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleChangeMount = (event) => {


        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms
        const {
            clean_gps,
            clean_seguro,
            clean_otros,
            nuevo_plazo,
            interes,
        } = formState
        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        const cuota_niv = paymentCalculation(clean_value, 0, interes, nuevo_plazo)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros)

        // console.log(cuota_niv, cuota_total);

        setFormState(prevState => ({
            ...prevState,
            // [ name ]: value,
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            clean_nuevo_cuota_niv: cuota_niv,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleClickResetPaymentSelection = () => {
    
        const { stepApplilication, setStepApplilication, formOpeningMode } = globalStates
        const { FormRequestGlobal, FormDeposit } = Forms

        if (formOpeningMode === 'EDITABLE') {
            FormRequestGlobal.setFormState(prevState => ({
                ...prevState,
                rowSelectedPayments: [], // reseteamos la selección de pagos
                transactions: [] // reseteamos las transacciones asociadas
            }))

            FormDeposit.setFormState(prevState => ({
                ...prevState,
                idpago: '' // reseteamos el id pago para el formulario
            }))
        }

        setStepApplilication(stepApplilication - 1)
    }

    const handleClickFetchTransactionsByPayment = (event) => {
        
        // const { name, value } = event.target

        const { stepApplilication, setStepApplilication } = globalStates
        // const { fetchTransactionsByPayment } = FetchData

        // const { FormRequestGlobal, FormDeposit } = Forms

        // console.log('[useActions][handleClickFetchTransactionsByPayment] { name, value } ', {name, value})
        // console.log('[useActions][handleClickFetchTransactionsByPayment] value[0] ', value[0])

        // if (formOpeningMode === 'EDITABLE') {
        //     // Setea selección (como un onInputChange)
        //     FormRequestGlobal.setFormState(prevState => ({
        //         ...prevState,
        //         [name]: value
        //     }))

        //     // Registra id pago para formulario de deposito
        //     FormDeposit.setFormState(prevState => ({
        //         ...prevState,
        //         idpago: parseInt(value[0].idpago, 10)
        //     }))

        //     // fetch de transacciones por pago
        //     fetchTransactionsByPayment.setParamsToSearch({
        //         idpago: parseInt(value[0].idpago, 10)
        //     })
        //     fetchTransactionsByPayment.executeFetch()
        // }

        // salta al siguiente paso
        setStepApplilication(stepApplilication + 1)
    }

    const handleClickTransactionForRetroactive = async () => {

        const { setModalOpeningMode } = globalStates
        const { FormDeposit } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        const idpago = FormDeposit.formState.idpago

        console.log('[useActions][handleClickTransactionForRetroactive] idpago ::: ', idpago)

        FormDeposit.onResetForm()
        FormDeposit.setFormState(prevState => ({
            ...prevState,
            idpago: parseInt(idpago, 10)
        }))
        
        setModalOpeningMode('EDITABLE')
        openModal('', 'Formulario de depositos', 'RetroactiveTransaction', {})

    }

    const onSubmitFormRetroTransaction = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers
        const { FormDeposit, FormRequestGlobal } = Forms

        // Validaciones obligatorias
        if (!FormDeposit.formState.movimiento_tipo || FormDeposit.formState.movimiento_tipo === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de movimiento',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }
        
        // Validaciones obligatorias
        if (!FormDeposit.formState.deposito_monto || FormDeposit.formState.deposito_monto === '') {
            const messageCustom = {
                message: 'Debe especificar el monto',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }
        
        // Validaciones obligatorias
        if (!FormDeposit.formState.deposito_moneda || FormDeposit.formState.deposito_moneda === '') {
            const messageCustom = {
                message: 'Debe especificar la moneda',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (FormDeposit.formState.movimiento_tipo === 'DEPOSITO') {
            if (!FormDeposit.formState.idbanco || FormDeposit.formState.idbanco === 0 || FormDeposit.formState.idbanco === '') {
                const messageCustom = {
                    message: 'Debe seleccionar un banco para depósitos',
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            }
        }

        if (FormDeposit.formState.movimiento_tipo === 'DEPOSITO') {

            if (FormDeposit.formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

        }

        const currentTransactions = FormRequestGlobal.formState.transactions

        console.log('[useActions][onSubmitFormRetroTransaction] currentTransactions ', currentTransactions)
        
        console.log('[useActions][onSubmitFormRetroTransaction] transactionToAdd ', FormDeposit.formState)

        const jsonBanco = JSON.parse(FormDeposit.idbanco);
        const newTransaction = {
            ...FormDeposit.formState,
            idmovimiento: nanoid(),
            idbanco: jsonBanco.idbanco,
            banco: jsonBanco.nombre,
            deposito_quetzal: FormDeposit.formState.deposito_quetzales,
            aprobacion_check: 'PENDIENTE',
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate(),
            usuario_creo: user.username,
            fecha_creo: getCurrentDate(),
            usuario_modifico: user.username,
            fecha_modifico: getCurrentDate(),
            oldRecord: false
        }

        console.log('[useActions][onSubmitFormRetroTransaction] transactionToAdd ', FormDeposit.formState)

        FormRequestGlobal.setFormState((prevState) => ({
            ...prevState,
            transactions: [
                ...prevState.transactions,
                newTransaction
            ]
        }))

        console.log('[useActions][onSubmitFormRetroTransaction] FormRequestGlobal.formState ', FormRequestGlobal.formState)

        closeModal()
        
        toast.success('Se agregó correctamente la transacción', {
            position: "top-right",
            theme: "colored"
        })

    }

    const handleClickDeleteItemFromTable = async ({itemId, paramSearch, arrayDataRowsName}) => {
        
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const newArray = formState[arrayDataRowsName].filter(item => item[itemId] !== paramSearch);
        setFormState(prevState => ({
            ...prevState,
            [ arrayDataRowsName ]: newArray
        }))

    }

    const handleClickFetchSpecificRetroTransaction = async (idmovimiento) => {

        const { setModalOpeningMode } = globalStates
        const { FormDeposit } = Forms


        const { fetchSpecificRetroTransaction } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificRetroTransaction

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        FormDeposit.onResetForm()
        console.log(idmovimiento);


        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        executeFetch()

        // setParamsToSearchDeposit({idcontrato: idcontrato})
        setModalOpeningMode('READONLY')
        openModal('', 'Formulario de depositos', 'RetroactiveTransaction', {})

    }




    return Object.freeze({
        handleClickCloseForm,
        handleChangeContract,
        onSubmitFormRequests,
        onSendLogs,
        handleClickShowModal,
        handleClickCloseModal,
        handleClickFetchInfoDeposit,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        onSubmitFormDeposits,
        onSubmitFormFiles,
        handleChangeTypeLoan,
        handleChangeTerm,
        handleChangeGPS,
        handleChangeOtros,
        handleChangeSeguro,
        handleChangeMount,
        handleClickDownloadImage,
        handleClickResetPaymentSelection,
        handleClickFetchTransactionsByPayment,
        handleClickTransactionForRetroactive,
        onSubmitFormRetroTransaction,
        handleClickDeleteItemFromTable,
        handleClickFetchSpecificRetroTransaction
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}